import { Check } from 'lucide-react';

import type { SocialPlatform } from '../../../../api/venues';
import { VerifiedAge } from '../../primitives/VerifiedAge';

import { PLATFORM_LABELS } from './social-form';

interface SocialVerifyCellProps {
  platform: SocialPlatform;
  /** When the platform was last checked. */
  verifiedAt: string | undefined;
  /** Whether there is a handle to verify. */
  hasHandle: boolean;
  /** Present only for someone who may edit marketing. */
  onVerify?: (platform: SocialPlatform) => void;
  busy: boolean;
  alignEnd: boolean;
}

/** How fresh a platform's details are, with a button to stamp them re-checked. */
export function SocialVerifyCell({
  platform,
  verifiedAt,
  hasHandle,
  onVerify,
  busy,
  alignEnd,
}: SocialVerifyCellProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px 8px',
        flexWrap: 'wrap',
        justifyContent: alignEnd ? 'flex-end' : 'flex-start',
        minWidth: 0,
      }}
    >
      {hasHandle ? (
        <VerifiedAge at={verifiedAt} compact />
      ) : (
        <span style={{ color: 'var(--nb-muted)' }}>—</span>
      )}
      {onVerify && hasHandle && (
        <button
          type="button"
          className="nb-btn nb-btn-ghost nb-tap"
          disabled={busy}
          aria-label={`Mark ${PLATFORM_LABELS[platform]} verified`}
          title="Re-checked the account and nothing changed. Stamp today."
          onClick={() => onVerify(platform)}
          style={{ height: 22, fontSize: 10, padding: '0 6px', whiteSpace: 'nowrap' }}
        >
          <Check size={10} aria-hidden="true" />
          Verify
        </button>
      )}
    </div>
  );
}
